module.exports = __webpack_public_path__ + "static/media/3.7188950b.jpg";